import { FunctionComponent, memo } from "react";

import { IProps } from "./interaction-metric-summary-value.types";
import { useInteractionMetricConversion } from "hooks-for/metrics/use-interaction-metric-conversion";
import { LoadingSkeleton, None } from "@edgetier/client-components";
import "./interaction-metric-summary-value.scss";

/**
 * Format and display an interaction metric summary value.
 * @param props.interactionMetric The interaction metric being displayed.
 * @param props.isMaybeLoading    When true, some agent data may still be loading.
 * @param props.value             The metric summary value.
 * @returns A formatted metric summary value with the relevant unit.
 */
const InteractionMetricSummaryValue: FunctionComponent<IProps> = ({ interactionMetric, isMaybeLoading, value }) => {
    const { formatTick, unitShorthand } = useInteractionMetricConversion(interactionMetric, {
        isAggregate: true,
        items: [value ?? 0],
        getValue: (value) => value,
    });

    return (
        <>
            {isMaybeLoading && (typeof value === "undefined" || value === null) ? (
                <LoadingSkeleton width={50} containerTestId="interaction-metric-summary-value__loading" />
            ) : typeof value === "undefined" || value === null ? (
                <None>N/A</None>
            ) : (
                formatTick(value, { maximumFractionDigits: 1 }) + (unitShorthand ?? "")
            )}
        </>
    );
};

export default memo(InteractionMetricSummaryValue);
